import { createContext } from 'react';

const activoTypeContext = createContext();

export default activoTypeContext;